import { createSwitchingStatusComposable } from '@/composables/create-switching-status-composable';

/**
 * Provides clustered switching job progress/cann-group status for display, via one of
 * two mechanisms selected by the `switching.usePollingForUpdates` feature flag:
 *  - Polling (flag on): actively fetches `/cluster-schemes/switching-service-job/status`
 *    on an interval.
 *  - Push (flag off, default): reads data already kept fresh in the scenarios store by
 *    the Dapr-driven statusUpdate SSE push (see stores/events.js).
 *
 * Auto-resumes polling on mount if a job is already in progress (polling mode only).
 * In push mode, fires a one-off reconciliation request on mount instead, so a job left
 * stuck by a missed/dropped Dapr event is corrected on page load. Stops on unmount.
 *
 * Returns `clusters` — an array of cluster objects each with `clusterName`, `status`,
 * and `cannGroups` — so callers can render granular per-cluster progress breakdowns.
 */
export const useClusteredSwitchingStatus = createSwitchingStatusComposable({
  statusUrl: id => `/api/scenarios/${id}/cluster-schemes/switching-service-job/status`,
  getJobStatus: jobStatuses => jobStatuses?.clusteredSwitching,
  getPollingDetails: statusData => statusData?.clusters,
  getPushDetails: status => status?.extra?.clusters,
  detailsKey: 'clusters',
});
